import * as React from "react";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";

export default function Shimmer() {
  return (
    <div>
      <Skeleton
        sx={{ height: 30, width: "150px", padding: "0px", margin: "0px" }}
      />
    </div>
  );
}
